import { CommonModule } from '@angular/common';
import { afterNextRender, Component, ElementRef, forwardRef, input, model, viewChild } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-input-number',
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './input-number.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputNumber),
            multi: true,
        },
    ],
})
export class InputNumber implements ControlValueAccessor {
    inputElement = viewChild.required<ElementRef>('inputElement');

    formControlName = input<string>('');
    placeholder = input<string>('연락처 입력해 주세요.');
    required = input<boolean>(false);
    readonly = input<boolean>(false);
    maxLength = input<number>(11);
    disabled = input<boolean>(false);
    value = model<string | number>('');

    constructor() {
        afterNextRender(() => {
            this.formatValue();
        });
    }

    formatValue(): void {
        setTimeout(() => {
            if (!this.value()) return;
            if (!this.inputElement()) return;

            const value = this.value()
                .toString()
                .replace(/[^0-9]/g, '');

            this.inputElement().nativeElement.value = value;
            this.value.set(value);
            this.onChange(value);
        }, 300);
    }

    writeValue(value: string) {
        this.value.set(value);
    }
    onChange = (value: string) => {};
    onTouched = () => {};
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {}

    onInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        let value = input.value.replace(/[^0-9]/g, '');

        if (this.maxLength()) value = value.slice(0, this.maxLength());
        this.inputElement().nativeElement.value = value;
        this.value.set(value);
        this.onChange(value);
        this.onTouched();
    }

    onBlur(): void {
        this.onTouched();
        this.formatValue();
    }
}
